/** 板件吸附范围 */
export const ADSORPTION_RANGE = 40

/** 来源 */
export enum From {
  BLUEN = 'bluen',
  LBL = 'erp',
  LBLL = 'lbl',
}

/** OSS 服务器地址 */
export const OSS_BASE_URL = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com'

/** 非云排板使用待排版库，如不存在显示的板件图片使用此默认图片 */
export const DEFAULT_SHOW_AWAIT_STORE_IMAGE =
  'https://eggrj.oss-cn-hangzhou.aliyuncs.com/cloud_paiban/await_store/await_store-temp.png'

/** 待排版库图片可存在的图片尺寸 */
export enum AwaitStoreImageSize {
  width = 128,
  height = 134,
}

/** 云排版使用的 cookie key */
export enum CookieKeys {
  /** 云排版的版本信息，用户灰度发布等场景 */
  BLUEN_VERSION = 'bluen_version',
}

/** 云排版版本信息 */
export enum BluenVersions {
  /** 稳定版 */
  v1 = 'v1',
  /** 灰度版本 */
  v2 = 'v2',
}

/** @description 使用此参数来暂停某部分代码得执行(临时处理才需要使用此变量) */
export const CODE_PAUSE = false

/** @description 会话存储的key */
export const SESSION_STORAGE_KEYS = {
  /** 通用板件数据源(通过此数据拿到的板件是各个平台跳转直接存储的板件，本质上云排版可以直接使用不用二次处理) */
  GENERAL_MATERIAL: 'general_material',
  /** 通用板件数据源类型 */
  GENERAL_MATERIAL_TYPE: 'general_material_type',
}

/** @description nc 文件存储的基础地址 */
export const OSS_NC_BASE_URL = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com'
